import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import { SaleCenterClosingSummary } from "../../types/sale-center-closing.type";
import { formatNumber } from "../../utils";
import { formatDateTimeBkk } from "../../utils/date";
import ClosingSectionBox from "./ClosingSectionBox";
import ClosingSummaryLine from "./ClosingSummaryLine";
import {
  CASH_COLLECTED_LABEL,
  EXPENSE_LABEL,
  MISSING_VALUE,
} from "./saleCenterClosing.utils";

interface ClosingOutcomeBoxProps {
  summary: SaleCenterClosingSummary;
}

/**
 * What was decided about a closed branch-day, for everyone who may read the report.
 *
 * Closing is the supervisor's alone, but the result of it is not: the branch back office and
 * the plain head-office accountant come here to see the cash head office counted, the
 * ยอดค่าใช้จ่าย (DIP) it left, and who froze the day when.
 *
 * It takes the place of the closing form once the day is frozen — there is nothing left to
 * key in — so it is laid out in the same column, against the sign-offs it was decided on.
 * Only the panel knows when there is an outcome to show, and it renders this only then.
 */
export default function ClosingOutcomeBox({ summary }: ClosingOutcomeBoxProps) {
  const closedAtLabel = formatDateTimeBkk(summary.closed_at);

  return (
    <ClosingSectionBox
      title="ผลการปิดศูนย์เซล"
      icon={AssignmentTurnedInOutlinedIcon}
      accent="success"
    >
      <Stack gap={1}>
        <ClosingSummaryLine
          label="ปิดศูนย์เซลโดย"
          value={summary.closed_by_name ?? MISSING_VALUE}
        />
        <ClosingSummaryLine
          label="เวลาที่ปิด"
          value={closedAtLabel ? `${closedAtLabel} น.` : MISSING_VALUE}
        />
        <Divider />
        <ClosingSummaryLine
          label={CASH_COLLECTED_LABEL}
          value={formatNumber(summary.cash_collected_amount)}
        />
        <ClosingSummaryLine
          label={EXPENSE_LABEL}
          value={formatNumber(summary.expense_amount)}
        />
        {summary.note && (
          <ClosingSummaryLine label="หมายเหตุ" value={summary.note} />
        )}
      </Stack>
    </ClosingSectionBox>
  );
}
